const PROMOTION_STATUSES = {
  scheduled: { name: "scheduled", id: "scheduled" },
  active: { name: "active", id: "active" },
  finished: { name: "finished", id: "finished" },
  blocked: { name: "blocked", id: "blocked" },
};

export default PROMOTION_STATUSES;
